<template>
  <BSCModal :sizeW="sizeW" :sizeH="sizeH" :zIndex="zIndex">
    <div class="BSCModalAction-content">
      <header class="BSCModalAction-content-header" :class="classTypeDialog">
        <slot name="header"></slot>
      </header>

      <main class="BSCModalAction-content-main">
        <slot></slot>
      </main>

      <footer class="BSCModalAction-content-footer">
        <BSCButton
          v-if="cancelText"
          class="BSCModalAction-content-footer-button  is-outline"
          :label="cancelText"
          :disabled="disabledCancel"
          :type="cancelType"
          @click.native="cancel"
        />

        <BSCButton
          class="BSCModalAction-content-footer-button"
          :label="confirmText"
          :disabled="disabledConfirm"
          :loading="loadingConfirm"
          :type="confirmType"
          @click.native="confirm"
        />
      </footer>
    </div>
  </BSCModal>
</template>

<script>
'use strict'

import BSCModal from './BSCModal'
import BSCButton from './BSCButton'

export default {
  name: 'BSCModalAction',
  components: {
    BSCModal,
    BSCButton
  },
  props: {
    sizeW: {
      type: Number
    },
    sizeH: {
      type: Number
    },
    zIndex: {
      type: Number,
      default: 900
    },
    type: {
      type: String,
      default: 'primary'
    },
    cancelText: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: 'Confirmer'
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    cancelType: {
      type: String,
      default: 'primary'
    },
    disabledConfirm: {
      type: Boolean,
      default: false
    },
    loadingConfirm: {
      type: Boolean,
      default: false
    },
    disabledCancel: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    confirm() {
      !this.disabledConfirm && this.$emit('confirm')
    },
    cancel() {
      !this.disabledCancel && this.$emit('cancel')
    }
  },
  computed: {
    classTypeDialog() {
      return [`is-${this.type}`]
    },
    classTypeConfirm() {
      return [
        `is-${this.confirmType}`,
        this.disabledConfirm ? 'is-disabled' : '',
        this.loadingConfirm ? 'is-loading' : ''
      ]
    },
    classTypeCancel() {
      return [`is-${this.cancelType}`, this.disabledCancel ? 'is-disabled' : '']
    }
  }
}
</script>
